import React from 'react';

import VisibilityOffIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityIcon from '@mui/icons-material/VisibilityOutlined';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';
import useStyles from './styles';

const VisibilityActionButton = (props: IBaseActionButtonProps) => {
  const { isActive, ...otehrProps } = props;

  return (
    <BaseActionButton {...otehrProps}>
      {isActive ? <VisibilityOffIcon /> : <VisibilityIcon />}
    </BaseActionButton>
  );
};

export default VisibilityActionButton;
